import React, {Fragment} from 'react';

export function Button(props) {
  function handleClick(e) {
    e.preventDefault();
    props.onClick();
    var elmnt = document.getElementById("all-winter");
    elmnt.scrollIntoView();
  }
  const value = (props.showAll) ? "Weniger anzeigen" : "Alle anzeigen";
  return (
    <Fragment>
      <div className="show-more">
        <button className="btn btn__show-more" onClick={handleClick}>{value}</button>
      </div>
    </Fragment>
  );
}
